module.exports = __webpack_public_path__ + "img/kuzzle-logo.c3fe4193.png";